/**
 * True when the browser can only offer software (CPU) WebGL - e.g. Lighthouse /
 * PageSpeed servers, some VMs and remote desktops. Rendering the 3D scenes there
 * would burn the main thread for the whole visit, so callers fall back to CSS.
 */
export function isSoftwareWebGL(): boolean {
  try {
    const c = document.createElement("canvas");
    const gl = (c.getContext("webgl2") || c.getContext("webgl")) as WebGLRenderingContext | null;
    if (!gl) return true;
    const ext = gl.getExtension("WEBGL_debug_renderer_info");
    const renderer = ext ? String(gl.getParameter(ext.UNMASKED_RENDERER_WEBGL)) : String(gl.getParameter(gl.RENDERER));
    gl.getExtension("WEBGL_lose_context")?.loseContext();
    return /swiftshader|llvmpipe|software|mesa offscreen|microsoft basic render/i.test(renderer);
  } catch {
    return true;
  }
}
